module.exports = __webpack_public_path__ + "static/media/phone.41316f2f.png";